/** Optional account restriction is evaluated before group/admin shortcuts. */
export function menuAccountAllowed(item, user) {
    return item.users === undefined || (Array.isArray(item.users) && item.users.includes(user?.username));
}
